import React$1 from 'react';
import { useFeatures } from '../../../../../../utilities/features/hooks.js';
import { classNames } from '../../../../../../utilities/css.js';
import { TextStyle as TextStyle$1 } from '../../../../../TextStyle/TextStyle.js';
import { DisplayText as DisplayText$1 } from '../../../../../DisplayText/DisplayText.js';
import styles from './Title.scss.js';

function Title({
  title,
  subtitle,
  titleMetadata,
  thumbnail
}) {
  const {
    newDesignLanguage
  } = useFeatures();
  const titleElement = newDesignLanguage ? /*#__PURE__*/React$1.createElement("h1", {
    className: styles.newDesignLanguageTitle
  }, title) : /*#__PURE__*/React$1.createElement(DisplayText$1, {
    size: "large",
    element: "h1"
  }, /*#__PURE__*/React$1.createElement(TextStyle$1, {
    variation: "strong"
  }, title));
  const titleMarkup = title ? /*#__PURE__*/React$1.createElement("div", {
    className: styles.Title
  }, titleElement) : null;
  const titleMetadataMarkup = titleMetadata ? /*#__PURE__*/React$1.createElement("div", {
    className: styles.TitleMetadata
  }, titleMetadata) : null;
  const wrappedTitleMarkup = titleMetadata ? /*#__PURE__*/React$1.createElement("div", {
    className: classNames(styles.TitleWithMetadataWrapper, newDesignLanguage && styles.newDesignLanguage)
  }, titleMarkup, titleMetadataMarkup) : titleMarkup;
  const subtitleMarkup = subtitle ? /*#__PURE__*/React$1.createElement("div", {
    className: styles.SubTitle
  }, /*#__PURE__*/React$1.createElement("p", null, subtitle)) : null;
  const thumbnailMarkup = thumbnail ? /*#__PURE__*/React$1.createElement("div", null, thumbnail) : null;
  const pageTitleClassName = thumbnail ? classNames(styles.hasThumbnail) : undefined;
  return /*#__PURE__*/React$1.createElement("div", {
    className: pageTitleClassName
  }, thumbnailMarkup, /*#__PURE__*/React$1.createElement("div", {
    className: styles.TitleAndSubtitleWrapper
  }, wrappedTitleMarkup, subtitleMarkup));
}

export { Title };
